import React, { useEffect, useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaGlobe } from "react-icons/fa";
import { useNavigate} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import { FaTools, FaUserCheck, FaShieldAlt, FaClipboardCheck } from "react-icons/fa";

/* Background Images */
import bg1 from "../image/burj-khalifa-4922317_1280.jpg";
// import bg2 from "../image/dubai-6331310_1280.jpg";
// import bg3 from "../image/address4044183_1280.jpg";
import bg4 from "../image/home1.jpeg";
import bg5 from "../image/home2.jpeg";
import bg6 from "../image/home3.jpeg";
import bg7 from "../image/home4.jpeg"
import bg8 from "../image/home5.jpeg"
import bg9 from "../image/home6.jpeg"
import bg10 from "../image/home7.jpeg"
import dubai from "../image/HH Al saud.png";
import bg11 from "../image/missing.jpeg";
import bg12 from "../image/IMG_7615.JPEG";

import img from "../image/electricl.png";
import img1 from "../image/HAVS.png";
import img2 from "../image/smart homen.jpg";
import img5 from "../image/ANNUAL MAINTANACEn.jpg";

/* Slideshow images array */
const bgImages = [bg4,bg5,bg6,bg7,bg8,bg9,bg10,bg11,bg12];

/* Expertise Card */
const ExpertiseCard = ({ title, text }) => (
  <div
    data-aos="fade-up"
    className="bg-white/60 backdrop-blur-lg border border-gray-200 rounded-3xl p-8 flex flex-col justify-center text-center shadow-2xl hover:scale-105 transition-transform"
  >
    <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">{title}</h3>
    <p className="text-gray-700 text-sm sm:text-base leading-relaxed">{text}</p>
  </div>
);

const HomeSection = () => {
  const [currentBg, setCurrentBg] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
    });
  }, []);

  /* Background slideshow effect */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % bgImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const homeServices = [
    {
      title: "Mechanical, Electrical & Plumbing",
      description: "Complete MEP solutions for luxury properties.",
      image: img,
      alt: "Mechanical, Electrical & Plumbing Service",
    },
    {
      title: "HVAC Systems",
      description: "Advanced heating, ventilation & air conditioning.",
      image: img1,
      alt: "HVAC System Service",
    },
    {
      title: "Smart Home Automation",
      description: "Modern smart home & automation systems.",
      image: img2,
      alt: "Smart Home Automation Service",
    },
    {
      title: "Annual Maintenance Contracts",
      description: "Reliable AMC plans for worry-free maintenance.",
      image: img5,
      alt: "Annual Maintenance Contract Service",
    },
  ];


  const items = [
  { text: "High-quality workmanship", icon: <FaTools /> },
  { text: "Certified technicians", icon: <FaUserCheck /> },
  { text: "Preventive maintenance", icon: <FaShieldAlt /> },
  { text: "Transparent service", icon: <FaClipboardCheck /> },
];

  return (
    <section className="w-full h-full overflow-x-hidden text-gray-800 bg-white">

      {/* ================= SEO + SCHEMA ================= */}
      <Helmet>
        <title>Bait Alafnan - Premium Property Maintenance UAE</title>
        <meta
          name="description"
          content="Trusted property maintenance services in UAE for villas, apartments, and commercial spaces. MEP, HVAC, smart home automation, and preventive maintenance."
        />
        <meta
          name="keywords"
          content="property maintenance UAE, MEP services Dubai, HVAC maintenance, smart home automation, annual maintenance contracts"
        />
        <meta property="og:title" content="MA Perfect Fix - Premium Property Maintenance UAE" />
        <meta
          property="og:description"
          content="Trusted property maintenance services in UAE for villas, apartments, and commercial spaces. MEP, HVAC, smart home automation, and preventive maintenance."
        />
        <meta property="og:image" content={bg1} />
        <meta property="og:type" content="website" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "MA Perfect Fix",
            image: bg1,
            url: "https://maperfectfix.com",
            telephone: " +971 50 414 7991",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Dubai",
              addressCountry: "AE",
            },
            sameAs: ["https://www.facebook.com/", "https://www.instagram.com/"],
            description:
              "Premium property maintenance services covering MEP, HVAC, smart homes, and preventive maintenance in UAE.",
          })}
        </script>

        {homeServices.map((service, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              name: service.title,
              provider: {
                "@type": "LocalBusiness",
                name: "MA Perfect Fix",
                telephone: " +971 50 414 7991",
                address: {
                  "@type": "PostalAddress",
                  addressLocality: "Dubai",
                  addressCountry: "AE",
                },
              },
              description: service.description,
              image: service.image,
            })}
          </script>
        ))}
      </Helmet>

      {/* ================= HERO SECTION ================= */}
      <section aria-label="Hero Section" className="relative w-full h-[90vh] sm:h-[100vh] lg:h-[110vh] overflow-hidden">
        {bgImages.map((img, i) => (
          <div
            key={i}
            className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${i === currentBg ? "opacity-100" : "opacity-0"}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}

        <div className="absolute inset-0 bg-black/10" />
        <div className="absolute top-0 left-0 w-72 h-72 bg-yellow-200 rounded-full opacity-20 -translate-x-20 -translate-y-20 animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-yellow-300 rounded-full opacity-10 translate-x-20 translate-y-20 animate-pulse"></div>

     <div className="relative flex flex-col justify-center items-start h-full px-6 text-left max-w-6xl mx-auto">
  <h1 data-aos="fade-up" className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight mt-16 text-white leading-tight uppercase">
    Immaculate 
     <span className="block text-white mt-4">
      Maintenance for
    </span>
      <span className="block text-white mt-4">
      Properties That Demand 
    </span>
    <span className="block text-white mt-4">
    Perfection
    </span>
  </h1>
  <p data-aos="fade-up" data-aos-delay="200" className="text-white/90 max-w-4xl mt-6 font-inter text-lg sm:text-base md:text-lg">
    Trusted technical maintenance for villas, premium apartments, and commercial spaces — executed with precision, discretion, and reliability across the UAE.
  </p>
  <button
    data-aos="fade-up"
    data-aos-delay="100"
    onClick={() => navigate("/services")}
    className="mt-8 px-8 py-3 rounded-full bg-yellow-400/90 text-gray-900 font-semibold hover:bg-yellow-500/90 hover:text-white transition"
  >
    Book Service Now
  </button>
</div>

      </section>

      {/* ================= WHO WE ARE & WHAT WE DO ================= */}
      <section aria-label="About Section" className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-0 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div data-aos="fade-up">
            <div className="bg-white/60 backdrop-blur-lg border border-gray-200 rounded-3xl p-8 sm:p-12 shadow-2xl hover:scale-105 transition-transform">
              <h2 className="text-4xl sm:text-5xl font-cormorant text-yellow-500 mb-6 text-center lg:text-left">
                Who We Are
              </h2>
              <p className="text-gray-700 font-inter text-base sm:text-lg leading-relaxed text-center lg:text-left">
                Bait Al Afnan Technical Services LLC is a UAE-based company specializing in property maintenance and technical solutions. Our mission is to maintain the highest standards in every project we undertake.
              </p>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
            <div className="bg-white/60 backdrop-blur-lg border border-gray-200 rounded-3xl p-8 sm:p-12 shadow-2xl hover:scale-105 transition-transform">
              <h2 className="text-4xl sm:text-5xl font-cormorant text-yellow-500 mb-6 text-center lg:text-left">
                What We Do
              </h2>
              <p className="text-gray-700 font-inter text-base sm:text-lg leading-relaxed text-center lg:text-left">
                We provide professional technical maintenance services covering MEP,
                HVAC systems, smart home automation, interior & exterior works,
                pools, safety systems, and utilities.
              </p>
            </div>
          </div>
        </div>

        {/* FEATURES LIST */}
        {/* <ul className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-12 mb-12 text-center">
          {["High-quality workmanship", "Certified technicians", "Preventive maintenance", "Transparent service"].map((item, index) => (
            <li key={index} className="flex justify-center items-center gap-3 text-gray-700 hover:text-yellow-500 transition">
              <span className="text-yellow-500 text-lg">✔</span>
              <span className="text-inter sm:text-lg">{item}</span>
            </li>
          ))}
        </ul> */}
 <div className="overflow-hidden w-full py-10 bg-gradient-to-r from-gray-50 to-white">
  <div className="flex w-max animate-marquee gap-6 hover:[animation-play-state:paused]">

    {[...items, ...items, ...items].map((item, index) => (
      <div
        key={index}
        className="min-w-[260px] sm:min-w-[300px] px-6 py-4 rounded-2xl 
        bg-white/70 backdrop-blur-lg border border-gray-200 
        shadow-lg flex items-center gap-4 
        hover:scale-105 hover:shadow-2xl transition duration-300"
      >
        {/* ICON */}
        <span className="text-yellow-500 text-2xl">
          {item.icon}
        </span>

        {/* TEXT */}
        <span className="font-montserrat font-medium text-gray-800 tracking-wide text-sm sm:text-base">
          {item.text}
        </span>
      </div>
    ))}

  </div>
</div>
        <div className="mt-10 flex justify-center">
          <button
            data-aos="fade-up"
            onClick={() => navigate("/about")}
            className="px-8 py-3 bg-yellow-400 border border-yellow-500 rounded-full text-gray-900 font-semibold hover:bg-yellow-500 hover:text-white transition"
          >
            Learn More About Our Company
          </button>
        </div>
      </section>

      {/* ================= INSPIRED & DRIVEN ================= */}
      {/* <section aria-label="Leadership Section" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-cormorant text-gray-900 mb-12">
            Inspired by Leadership <br /> Driven by Excellence
          </h2>

          <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-8 items-center">
            <img
              data-aos="fade-up"
              src={dubai}
              alt="HH Prince Turki Abdulaziz Faisal Al Saud"
              className="w-[280px] sm:w-[320px] md:w-[360px] rounded-xl mx-auto sm:mx-0 sm:ml-[50px] shadow-2xl"
            />
            <div data-aos="fade-up" className="bg-white/60 backdrop-blur-lg border border-gray-200 rounded-2xl p-6 sm:p-8 shadow-xl">
              <p className="text-gray-700 font-inter text-lg leading-relaxed">
                Inspired by visionary leadership, integrity, and excellence—values long associated with the distinguished legacy of HH Prince Turki Abdulaziz Faisal Al Saud—our organization is guided by principles of responsibility, discipline, and long-term thinking.
                <br /><br />
                These values shape how we operate and how we serve. They guide our commitment to delivering premium technical services with professionalism, precision, and trust. Every service is carried out with attention to detail, accountability, and respect for quality.
                <br /><br />
                True excellence is built through consistency, ethical practice, and dependable results over time. This foundation allows us to deliver carefully planned and well-executed technical solutions for clients who value integrity and long-term partnership.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* ================= SERVICES ================= */}
      <section aria-label="Services Section">
        <div className="text-center mt-20" data-aos="fade-up">
          <h2 className="text-5xl font-cormorant text-gray-900">How Can We Help You?</h2>
        </div>
        <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {homeServices.map((service, index) => (
            <div
              key={index}
              onClick={() => navigate("/services")}
              data-aos="fade-up"
              data-aos-delay={index * 200}
              className="cursor-pointer bg-white/60 backdrop-blur-lg border border-gray-200 rounded-3xl overflow-hidden shadow-xl hover:scale-105 transition"
            >
              <img
                src={service.image}
                alt={service.alt}
                className="h-48 w-full object-cover group-hover:scale-105 transition duration-500"
              />
              <div className="p-6 text-center">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-700 text-sm sm:text-base">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mb-20" data-aos="fade-up">
          <button
            onClick={() => navigate("/services")}
            className="px-9 py-3 rounded-full bg-yellow-400 text-gray-900 font-semibold hover:bg-yellow-500 hover:text-white transition"
          >
            View All Services
          </button>
        </div>
      </section>

       {/* ================= INSPIRED & DRIVEN ================= */}
      <section aria-label="Leadership Section" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-cormorant text-gray-900 mb-12">
            Inspired by Leadership <br /> Driven by Excellence
          </h2>

          <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-8 items-center">
            <img
              data-aos="fade-up"
              src={dubai}
              alt="HH Prince Turki Abdulaziz Faisal Al Saud"
              className="w-[280px] sm:w-[320px] md:w-[360px] rounded-xl mx-auto sm:mx-0 sm:ml-[50px] shadow-2xl"
            />
            <div data-aos="fade-up" className="bg-white/60 backdrop-blur-lg border border-gray-200 rounded-2xl p-6 sm:p-8 shadow-xl">
              <p className="text-gray-700 font-inter text-lg leading-relaxed">
                Inspired by visionary leadership, integrity, and excellence—values long associated with the distinguished legacy of HH Prince Turki Abdulaziz Faisal Al Saud—our organization is guided by principles of responsibility, discipline, and long-term thinking.
                <br /><br />
                These values shape how we operate and how we serve. They guide our commitment to delivering premium technical services with professionalism, precision, and trust. Every service is carried out with attention to detail, accountability, and respect for quality.
                <br /><br />
                True excellence is built through consistency, ethical practice, and dependable results over time. This foundation allows us to deliver carefully planned and well-executed technical solutions for clients who value integrity and long-term partnership.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= WHY US ================= */}
      <section aria-label="Why Us Section">
        <div className="text-center mb-10" data-aos="fade-up">
          <h2 className="text-5xl font-cormorant text-gray-900 mb-4">WHY US</h2>
          <p className="text-gray-700 font-inter text-lg max-w-2xl mx-auto mt-6 leading-relaxed">
            White-glove service, end-to-end technical expertise, and preventive
            asset protection tailored for high-end properties.
          </p>
        </div>

        <div className="max-w-7xl mx-auto px-6 pt-14 pb-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <ExpertiseCard title="WHITE GLOVE SERVICE" text="Discreet, clean, and minimally disruptive maintenance for luxury properties." />
          <ExpertiseCard title="END-TO-END EXPERTISE" text="MEP, HVAC, smart systems, and specialist maintenance under one roof." />
          <ExpertiseCard title="PREVENTIVE PROTECTION" text="Proactive inspections to reduce failures and preserve asset value." />
        </div>
      </section>

     <section
  aria-label="Contact Section"
  className="bg-gradient-to-r from-white to-gray-50 py-16 text-center mt-20 rounded-2xl shadow-xl"
  data-aos="fade-up"
>
  <h2 className="text-3xl font-cormorant text-gray-900 mb-6">
    Get in Touch
  </h2>

  <p className="text-gray-700 font-inter mb-8">
    Have a question or need professional maintenance services?
  </p>

  {/* CONTACT INFO */}
  <div className="flex flex-col sm:flex-row justify-center gap-6 text-gray-800 mb-10">
    <div className="flex items-center gap-3 justify-center bg-white px-5 py-3 rounded-xl shadow hover:shadow-lg transition">
      <FaPhoneAlt className="text-yellow-500" />
      +971 50 414 7991
    </div>

    <div className="flex items-center gap-3 justify-center bg-white px-5 py-3 rounded-xl shadow hover:shadow-lg transition">
      <FaEnvelope className="text-yellow-500" />
      contact@baitalafnan.com
    </div>

    <div className="flex items-center gap-3 justify-center bg-white px-5 py-3 rounded-xl shadow hover:shadow-lg transition">
      <FaGlobe className="text-yellow-500" />
      www.baitalafnan.com
    </div>
  </div>

  {/* WHATSAPP BUTTON
  <a
    href="https://wa.me/971504147991?text=Hello%20I%20need%20service"
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center gap-3 px-8 py-4 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 hover:scale-105 transition duration-300"
  >
    {/* WhatsApp Icon */}
    {/* <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M20.52 3.48A11.8 11.8 0 0012.03 0C5.4 0 .02 5.38.02 12c0 2.12.55 4.2 1.6 6.04L0 24l6.18-1.62A11.94 11.94 0 0012.03 24c6.63 0 12.01-5.38 12.01-12 0-3.2-1.25-6.2-3.52-8.52zM12.03 21.8c-1.8 0-3.55-.5-5.06-1.45l-.36-.21-3.67.96.98-3.57-.23-.37a9.77 9.77 0 01-1.5-5.16c0-5.4 4.4-9.8 9.84-9.8 2.63 0 5.1 1.02 6.96 2.88a9.77 9.77 0 012.88 6.92c0 5.4-4.4 9.8-9.84 9.8zm5.4-7.35c-.3-.15-1.78-.88-2.05-.98-.27-.1-.46-.15-.66.15-.2.3-.76.98-.94 1.18-.17.2-.35.23-.65.08-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.48-1.74-1.65-2.04-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.53.15-.17.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.66-1.6-.9-2.2-.24-.58-.48-.5-.66-.51h-.56c-.2 0-.53.08-.8.38-.27.3-1.05 1.03-1.05 2.52s1.08 2.93 1.23 3.13c.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.43.25-.7.25-1.3.17-1.43-.08-.13-.27-.2-.56-.35z" />
    </svg>

    Chat on WhatsApp
  </a> */} 
</section>
    </section>
  );
};

export default HomeSection;
